import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Artiste } from '../models/artiste.model';

@Injectable({
  providedIn: 'root'
})
export class ArtisteService {

  // Adresse de notre API backend (Spring Boot)
  private apiUrl = 'https://be.festivalsousse.com/api/artistes';

  constructor(private http: HttpClient) { }

  getArtistes(): Observable<Artiste[]> {
    return this.http.get<Artiste[]>(this.apiUrl);
  }

  getArtisteById(id: number): Observable<Artiste> {
    return this.http.get<Artiste>(`${this.apiUrl}/${id}`);
  }

  createArtiste(artiste: Artiste): Observable<Artiste> {
    return this.http.post<Artiste>(this.apiUrl, artiste);
  }

  updateArtiste(id: number, artiste: Artiste): Observable<Artiste> {
    return this.http.put<Artiste>(`${this.apiUrl}/${id}`, artiste);
  }

  deleteArtiste(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
